import { useEffect, useRef, useState } from "react";

export default function useLoading() {
    const mounted = useRef(true)
    const [state, setState] = useState(false)

    useEffect(() => {
        return () => { mounted.current = false }
    }, [])

    const start = () => mounted.current && setState(true)
    const end = () => mounted.current && setState(false)
    const until = async (fn: () => Promise<void>) => {
        try {
            start()
            await fn()    
        } finally {
            end()
        }
    }

    return { state, start, end, until }
}